export const DEFAULT_MOCK_ROWS = 15;

export const HIDE_SORT_ICON_CLASS = 'hideSortIcon';

export const ENGINE_DEFAULTS = {
  manual: true,
  minRows: 0,
  showPagination: false
};

/**
 * Column keys whose value may be static or a `(ctx) => value` resolver, evaluated once per
 * build. Render-time callbacks (`header`, `cell`, `cellProps`, `expander`) are NOT in this list:
 * those receive `ctx` as their last argument when the engine calls them.
 */
export const RESOLVABLE_COLUMN_KEYS = [
  'visible',
  'order',
  'sortable',
  'resizable',
  'width',
  'minWidth',
  'maxWidth',
  'style',
  'headerStyle',
  'className',
  'headerClassName'
];

/**
 * How many engine arguments each render callback receives before `ctx`. The fixed arity keeps
 * `ctx` in the documented position instead of after whatever extra arguments the engine adds.
 */
export const RENDER_ARITY = {
  Header: 1,
  Cell: 1,
  Expander: 1
};
